import axios from "axios";
import { environment } from "../environments/environment";
import SiteModel, { CopiasSitesModel } from "../models/layout.model";

const config: any = {
    headers: {}
};

export const api = axios.create({
    //baseURL: environment.apiMockUrl
    baseURL: environment.serverUrl
});

export async function GetSiteService(dto: {
    ID: string | undefined | null,
}) {
    let url = '/?apis=get-site';
    return await api.post(url, dto, config);
}

export async function GetCopiaService(dto: {
    ID: string | undefined | null,
}) {
    let url = '/?apis=get-copia';
    return await api.post(url, dto, config);
}

export async function SaveSiteService(dto: SiteModel) {
    let url = '/?apis=save-site';
    return await api.post(url, dto, config);
}

export async function InsereSiteService(dto: CopiasSitesModel) {
    let url = '/?apis=inserir-copia';
    return await api.post(url, dto, config);
}

export async function AtualizaSiteService(dto: CopiasSitesModel) {
    let url = '/?apis=atualizar-copia';
    return await api.post(url, dto, config);
}

export async function ListMediaService(dto: {
    ID: string
}) {
    let url = '/?apis=list-media';
    return await api.post(url, dto, config);
}

export async function UploadFileService(formData: any) {
    let url = '/?apis=upload-file';
    return await api.post(url, formData, config);
}

export async function EnviaContatoService(dto: {
    author_id: string,
    nome_do_site: string,
    logo: string,
    email_para_envio_do_formulario: string,
    nome: string,
    email: string,
    telefone: string,
    empresa: string,
    mensagem: string,
}) {
    let url = '/?apis=envia-contato';
    return await api.post(url, dto, config);
}